import { Grid } from '@mui/material';
import { RoutalLoader, RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';
import Button, { ButtonProps } from '../react-components/Button';
import { Text } from '../react-components/Text';

interface LoadingButtonInternalProps extends ButtonProps {
  intlId?: string;
  intlValues?: Record<string, string | number | ((chunks: any) => React.ReactElement)>;
  isLoading?: boolean;
}

export type LoadingButtonProps = React.PropsWithChildren<LoadingButtonInternalProps> &
  React.HTMLAttributes<LoadingButtonInternalProps> &
  React.ButtonHTMLAttributes<LoadingButtonInternalProps>;

export const LoadingButton = (props: LoadingButtonProps) => {
  const { children, intlId, intlValues, isLoading, onClick, ...remainingProps } = props;
  return isLoading ? (
    <Button {...remainingProps}>
      <Grid style={{ opacity: 0.3, display: `flex` }}>
        {intlId && <Text variant="body" intlId={intlId} intlValues={intlValues} style={{ marginRight: `8px` }} />}

        {children}
      </Grid>
      <div style={{ display: `flex`, alignContent: `center`, position: `absolute` }}>
        <RoutalLoader color={RoutalPalette.white} style={{ width: `24px`, height: `auto`, opacity: 1 }} />
      </div>
    </Button>
  ) : (
    <Button intlId={intlId} intlValues={intlValues} onClick={onClick} {...props}>
      {children}
    </Button>
  );
};
